import React, { useEffect, useState, useRef } from "react";
import Swiper from "react-id-swiper";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/lazy/lazy.min.css";
import SectionHeader from "../sectionHeader/sectionHeader";
import { getPlaylist, getAWSUrl } from "../api/core";
import Global from "../../global";
import SwiperCore, { Navigation, Pagination, Lazy } from "swiper/core";
import Anchor from "../Link/anchor";
import { Link } from "react-router-dom";
import Icon from "../icon/icon";
import { BORDER } from "../../global";

// install Swiper modules
SwiperCore.use([Lazy, Navigation, Pagination]);

const NPortaritSlider = (props) => {
  const mounted = useRef(false);
  const init = { playlist: [] };
  const [pselem, setPSElem] = useState([]);
  const [pselemItem, setPSItem] = useState([]);
  const [psplaylist, setPSPlaylist] = useState(init);
  const [loading, isLoading] = useState(true);
  /* eslint-disable no-unused-vars */
  const [error, SetError] = useState(false);
  const [elempsdisplay, setPSElemDisplay] = useState(true);
  const [desc, setDesc] = useState(false);
  /* eslint-disable no-unused-vars */
  const [news, setNews] = useState(false);
  /* eslint-disable no-unused-vars */
  const [viewpsAll, setViewpsAll] = useState("");
  const [viewpsLink, setviewpsLink] = useState("");
  const params = {
    slidesPerView: 2,
    slidesPerGroup: 2,

    spaceBetween: 5,
    centeredSlides: false,
    speed: 800,
    loop: false,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
    observer: true,
    observeParents: true,
    rebuildOnUpdate: true,
    breakpoints: {
      320: {
        slidesPerView: 3,
        spaceBetween: 5,
        slidesPerGroup: 3,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      400: {
        slidesPerView: 3,
        spaceBetween: 5,
        slidesPerGroup: 3,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      576: {
        slidesPerView: 4,
        spaceBetween: 5,
        slidesPerGroup: 4,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      660: {
        slidesPerView: 4,
        spaceBetween: 5,
        slidesPerGroup: 4,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      720: {
        slidesPerView: 5,
        spaceBetween: 5,
        slidesPerGroup: 5,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 5,
        slidesPerGroup: 5,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      1200: {
        slidesPerView: 6,
        spaceBetween: 8,
        slidesPerGroup: 5,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
      1300: {
        slidesPerView: 7,
        spaceBetween: 8,
        slidesPerGroup: 6,
        navigation: {
          nextEl: props.tabbed
            ? "." + props.named + "next"
            : "." + props.name + "next",
          prevEl: props.tabbed
            ? "." + props.named + "prev"
            : "." + props.name + "prev",
        },
      },
    },
  };

  useEffect(() => {
    mounted.current = true;
    const PSElemDetail = async () => {
      if (mounted.current) {
        /* eslint-disable no-unused-vars */
        setPSElem(props.tabbed ? props.tabid : props.information);
        setPSElemDisplay(
          props.tabbed
            ? props.tabid.devices[0].itemVisibility
            : props.information.devices[0].itemVisibility
        );
        setPSItem(props.tabbed ? props.tabid.items : props.information.items);

        if (!props.tabbed) {
          if (
            props.information.playlistId !== null &&
            props.information.playlistId !== ""
          ) {
            PSplaylistDetail(
              props.information.playlistId,
              props.information.devices[0].itemSize
            );
          }
          props.information.displayNameVisibility === "On Hover" ||
          props.information.displayNameVisibility === "Show Always" ||
          props.information.displayNameVisibility === "Show Header Only"
            ? setDesc(true)
            : setDesc(false);
          props.information.displayNameVisibility === "Show Always"
            ? setNews(true)
            : setNews(false);
          props.information.viewAllVisibility === true &&
          props.information.viewAllText !== null
            ? setViewpsAll(props.information.viewAllText)
            : setViewpsAll("");
          if (
            props.information.viewAllVisibility === true &&
            props.information.viewAllPage !== null
          ) {
            const link =
              props.information.viewAllPage.pageType === "externalPage"
                ? props.information.viewAllPage.externalPage
                : props.information.viewAllPage.pageType === "internalPage"
                ? "/" +
                  props.match.params.AppId +
                  "/" +
                  props.information.viewAllPage.internalPage
                : props.information.viewAllPage.urlName !== ""
                ? "/" +
                  props.match.params.AppId +
                  "/" +
                  props.information.viewAllPage.urlName
                : "/" +
                  props.match.params.AppId +
                  "/page/" +
                  props.information.viewAllPage._id;
            setviewpsLink(link);
          }
        } else {
          if (
            props.tabid.playlistId !== null &&
            props.tabid.playlistId !== ""
          ) {
            PSplaylistDetail(
              props.tabid.playlistId,
              props.tabid.devices[0].itemSize
            );
          }
          props.tabid.displayNameVisibility === "On Hover" ||
          props.tabid.displayNameVisibility === "Show Always" ||
          props.tabid.displayNameVisibility === "Show Header Only"
            ? setDesc(true)
            : setDesc(false);
          props.tabid.displayNameVisibility === "Show Always"
            ? setNews(true)
            : setNews(false);
          props.tabid.viewAllVisibility === true &&
          props.tabid.viewAllText !== null
            ? setViewpsAll(props.tabid.viewAllText)
            : setViewpsAll("");
          if (
            props.tabid.viewAllVisibility === true &&
            props.tabid.viewAllPage !== null
          ) {
            const links =
              props.tabid.viewAllPage.pageType === "externalPage"
                ? props.tabid.viewAllPage.externalPage
                : props.tabid.viewAllPage.pageType === "internalPage"
                ? props.tabid.viewAllPage.internalPage
                : "/" +
                  props.match.params.AppId +
                  "/" +
                  props.tabid.viewAllPage.pageType +
                  "/" +
                  props.tabid.viewAllPage._id;
            setviewpsLink(links);
          }
        }
      }

      /* eslint-disable no-unused-vars */
    };

    const PSplaylistDetail = async (id, limit) => {
      /* eslint-disable no-unused-vars */

      const result = await getPlaylist(id, limit).then(
        (result) => {
          if (mounted.current) {
            setPSPlaylist(result.data);
            isLoading(false);
          }
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */
    };

    PSElemDetail();
    isLoading(false);
    return () => {
      mounted.current = false;
    };
  }, [props.match.params.AppId, props.information, props.tabid, props.tabbed]);
  if (
    elempsdisplay &&
    !error &&
    !loading &&
    (props.information || props.tabid)
  ) {
    return (
      <div className="portrait">
        <SectionHeader
          title={pselem.displayName}
          linkTitle={viewpsAll}
          link={viewpsLink}
          header={props.header}
        ></SectionHeader>
        <div className="container-fluid">
          <div>
            <div className="col-sm-12 slider_container">
              <div className="slide-wrapper">
                <Swiper
                  className="slide-slider  swiper-container"
                  {...params}
                  shouldSwiperUpdate
                >
                  {pselemItem !== null
                    ? pselemItem.map((item, index) =>
                        item.itemid.devices[0].itemVisibility ? (
                          <div className="swiper-slide" key={index}>
                            <Anchor
                              className={
                                BORDER ? "slide-one" : "slide-one no-border"
                              }
                              to={
                                item.itemid.pageType === "externalPage"
                                  ? item.itemid.externalPage
                                  : item.itemid.pageType === "internalPage"
                                  ? item.itemid.internalPage
                                  : item.itemid.pageType === "videoPage"
                                  ? "/" +
                                    props.match.params.AppId +
                                    "/" +
                                    item.itemid.pageType +
                                    "/" +
                                    item.itemid.videoId
                                  : item.itemid.urlName !== ""
                                  ? "/" +
                                    props.match.params.AppId +
                                    "/" +
                                    item.itemid.urlName
                                  : item.itemid.pageType + "/" + item.itemid._id
                              }
                            >
                              <div
                                className={
                                  BORDER
                                    ? "slide-image"
                                    : "slide-image no-border"
                                }
                              >
                                <img
                                  className="swiper-lazy"
                                  src={
                                    item.itemid.portraitThumbnail
                                      ? getAWSUrl() +
                                        item.itemid.portraitThumbnail.imagekey
                                      : ""
                                  }
                                  alt="Carousel"
                                />
                              </div>
                              <div
                                className={
                                  desc
                                    ? "slide-content"
                                    : "slide-content hidden"
                                }
                              >
                                <h2>
                                  {item.itemid.displayName}{" "}
                                  {Global.FAVOURITES ? (
                                    <span className="span">
                                      {" "}
                                      <i className="ri-add-line"></i>
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </h2>
                                <div>
                                  <span className="tag">
                                    {item.itemid.rating}
                                  </span>
                                  <span className="tag"></span>
                                </div>
                                <p>{item.itemid.description}</p>
                              </div>
                            </Anchor>
                            <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                          </div>
                        ) : (
                          <div
                            key={index}
                            className="none"
                            style={{ display: "none" }}
                          ></div>
                        )
                      )
                    : ""}

                  {psplaylist.playlist !== undefined
                    ? psplaylist.playlist.map((item, index) => (
                        <div className="swiper-slide" key={index}>
                          <Link
                            className={
                              BORDER ? "slide-one" : "slide-one no-border"
                            }
                            to={
                              "/" +
                              props.match.params.AppId +
                              "/videoPage/" +
                              item.mediaid
                            }
                          >
                            {item.ContentType === "Premium" ? (
                              <Icon></Icon>
                            ) : (
                              ""
                            )}
                            <div
                              className={
                                BORDER ? "slide-image" : "slide-image no-border"
                              }
                            >
                              <img
                                src={
                                  item.PortraitImage ? item.PortraitImage : ""
                                }
                                alt="Carousel"
                              />
                            </div>
                            <div
                              className={
                                desc ? "slide-content" : "slide-content hidden"
                              }
                            >
                              <h2>
                                {item.title}{" "}
                                {Global.FAVOURITES ? (
                                  <span className="span">
                                    {" "}
                                    <i className="ri-add-line"></i>
                                  </span>
                                ) : (
                                  ""
                                )}
                              </h2>
                              <div>
                                <span className="tag">
                                  {item.VIdeoDuration}
                                </span>
                                <span className="tag">{item.PgRating}</span>
                              </div>
                              <p>{item.ShortDescription}</p>
                            </div>
                          </Link>
                        </div>
                      ))
                    : ""}
                </Swiper>
                <div
                  id={`arrows_${props.tabbed ? props.named : props.name}`}
                  className={
                    props.tabbed
                      ? props.named + "prev swiper-arrows swiper-button-prev"
                      : props.name + "prev swiper-arrows swiper-button-prev"
                  }
                />
                <div
                  id={`arrows_${props.tabbed ? props.named : props.name}`}
                  className={
                    props.tabbed
                      ? props.named + "next swiper-arrows swiper-button-next"
                      : props.name + "next swiper-arrows swiper-button-next"
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (elempsdisplay && !error && loading) {
    return <div style={{ minHeight: "400px" }}></div>;
  } else {
    return <div></div>;
  }
};

export default NPortaritSlider;
